import { render, staticRenderFns } from "./Index2026.vue?vue&type=template&id=0b524342&scoped=true&"
import script from "./Index2026.vue?vue&type=script&lang=js&"
export * from "./Index2026.vue?vue&type=script&lang=js&"
import style0 from "./Index2026.vue?vue&type=style&index=0&id=0b524342&lang=scss&scoped=true&"
import style1 from "./Index2026.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b524342",
  null
  
)

export default component.exports